import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  font-family: 'Poppins, sans-serif';
  padding: 60px 0;
  background: #f9f9f9;

  .section-title {
    text-align: center;
    margin-bottom: 50px;

    h2 {
      font-size: 32px;
      margin-bottom: 10px;
    }

    img {
      max-width: 80px;
    }
  }
`;

const ServicesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
`;

const ServiceCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  flex: 1 1 calc(33.333% - 40px);
  max-width: calc(33.333% - 40px);
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  img {
    width: 80px;
    margin-bottom: 20px;
  }

  h4 {
    font-size: 20px;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    line-height: 1.6;
    color: #555;
  }

  @media (max-width: 992px) {
    flex: 1 1 calc(50% - 30px);
    max-width: calc(50% - 30px);
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

const Services = () => {
  const servicesData = [
    {
      img: 'img/services/01.png',
      title: 'Prepaid Recharge',
      desc: `We offer quick and convenient prepaid recharge solutions for
      mobile phones, helping customers stay connected without any
      hassle. Our platform supports a wide range of operators,
      ensuring seamless top-ups anytime, anywhere.`,
    },
    {
      img: 'img/services/02.png',
      title: 'DTH Recharge',
      desc: `With our DTH recharge service, customers can easily recharge
      their Direct-to-Home (DTH) connections, ensuring uninterrupted
      entertainment. Our fast and secure platform supports multiple
      DTH service providers.`,
    },
    {
      img: 'img/services/03.png',
      title: 'Bill Payment',
      desc: `Our utility bill payment service simplifies the process of
      paying bills for electricity, water, gas, and more. With a few
      clicks, customers can settle their monthly bills quickly,
      securely, and on time.`,
    },
    {
      img: 'img/services/04.png',
      title: 'DMT',
      desc: `The Domestic Money Transfer (DMT) service is a significant
      market in India, which has gained even more momentum with the
      recent rise in digital transactions`,
    },
    {
      img: 'img/services/05.png',
      title: 'AEPS',
      desc: `The Aadhaar Enabled Payment System (AEPS) is a payment platform
      that leverages the Unique Identification Number, enabling
      Aadhaar cardholders to seamlessly carry out financial
      transactions.`,
    },
    {
      img: 'img/services/06.png',
      title: 'Pancard',
      desc: `We support PAN card services through UTI. We invite partners to
      become PAN Service Agents (PSA).`,
    },
    {
      img: 'img/services/07.png',
      title: 'White Label Account',
      desc: `Our white label account service allows businesses to offer
      recharge and payment solutions under their own brand. This
      customizable solution helps businesses enhance their services
      while maintaining a professional and personalized customer
      experience.`,
    },
    {
      img: 'img/services/08.png',
      title: 'B2B Software (Admin)',
      desc: `Our B2B admin software provides businesses with an efficient
      platform to manage recharge operations, track transactions, and
      handle customer queries. It empowers business owners with
      real-time reporting and streamlined management tools for
      improved performance.`,
    },
    {
      img: 'img/services/09.png',
      title: 'Software Development',
      desc: `We specialize in custom software development, creating tailored
      solutions that meet the unique needs of your business. From web
      and mobile applications to complex enterprise systems, we
      deliver robust, scalable, and user-friendly software to help
      businesses grow.`,
    },
  ];

  return (
    <Section id="services-link">
      <div className="container">
        <div className="section-title">
          <h2>We Offer Different Services</h2>
          <img src="img/section-img.png" alt="Section Icon" />
        </div>
        <ServicesGrid>
          {servicesData.map((service, index) => (
            <ServiceCard key={index}>
              <img src={service.img} alt={service.title} />
              <h4>{service.title}</h4>
              <p>{service.desc}</p>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </div>
    </Section>
  );
};

export default Services;
